import React, { useEffect } from 'react';
import { UtilityBar } from '../components/UtilityBar';
import { SiteHeader } from '../components/SiteHeader/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';
import { QuoteIntro } from '../components/quote/QuoteIntro';
import { QuoteRequestPanel } from '../components/quote/QuoteRequestPanel';
import { QuoteHelpPanel } from '../components/quote/QuoteHelpPanel';
export function RequestQuote() {
  useEffect(() => {
    document.title = 'Request a Quote | Motor City Truck Collision';
  }, []);
  return <div className="min-h-screen w-full bg-paper font-sans text-ink" data-id="element-397" data-mp="blwv436p1nb2">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-ink focus:px-4 focus:py-3 focus:text-paper" data-id="element-398" data-mp="gfiyt5uvqguq">
        Skip to content
      </a>
      <UtilityBar data-id="element-399" data-mp="pgqx3nxebhot" />
      <SiteHeader data-id="element-400" data-mp="pd32elg7sp8i" />
      <main id="main" data-id="element-401" data-mp="ue8wamlm2ijm">
        <QuoteIntro data-id="element-402" data-mp="udhau4lqa172" />
        <section aria-label="Quote request form" className="bg-paper py-12 md:py-20" data-id="element-403" data-mp="uf0t20qy2mbh">
          <div className="mx-auto grid max-w-[1320px] gap-8 px-5 sm:px-8 lg:grid-cols-12 lg:items-start lg:gap-12 lg:px-12" data-id="element-404" data-mp="6efhzhr8ma7g">
            <div className="min-w-0 lg:col-span-8" data-id="element-405" data-mp="2ahj985tr1ex">
              <QuoteRequestPanel data-id="element-406" data-mp="3thkc041b9fr9" />
            </div>
            <div className="lg:sticky lg:top-28 lg:col-span-4" data-id="element-407" data-mp="3tic6tcn339gh">
              <QuoteHelpPanel data-id="element-408" data-mp="3ok0yj6cft70d" />
            </div>
          </div>
        </section>
      </main>
      <SiteFooter data-id="element-409" data-mp="q1mzhofofvpr" />
    </div>;
}